export default __webpack_public_path__ + "static/media/JuneDom2024.4cb1e428.png";